import { initWorkSliders } from "./components/work-sliders";
import { initBottomNav } from "./components/bottom-nav";
import "./components/scoll.min";
import "./components/scrollreveal.min";

// Инициализация компонентов
document.addEventListener("DOMContentLoaded", () => {
  initWorkSliders();
  initBottomNav();
});
